import ApiService from "@/services/Api"

import { ClientNote } from "@/protocols/clientNote"

type CreateClientNoteInput = {
	clientId: number
	inboxChannelChatId: number
	content: string
}

type RetrieveByClientIdParams = {
	rows?: number
}

class ClientNoteService {
	async create (input: CreateClientNoteInput): Promise<ClientNote> {
		const response = await ApiService.post<ClientNote>("/client-notes", input)

		return response.data
	}

	async retrieveByClientId (clientId: number, params?: RetrieveByClientIdParams): Promise<ClientNote[]> {
		const response = await ApiService.get<{ notes: ClientNote[] }>(`/client-notes/${clientId}`, {
			params
		})

		return response.data.notes
	}

	async update (noteId: number, input: { content: string }): Promise<void> {
		await ApiService.put(`/client-notes/${noteId}`, input)
	}

	async remove (noteId: number): Promise<void> {
		await ApiService.delete(`/client-notes/${noteId}`)
	}
}

export default new ClientNoteService()
